import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ProjectDto, ProjectInfo } from 'projects/shared/src/lib/models/Project';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'project-api-info',
  templateUrl: './project-api-info.component.html',
  styleUrls: ['./project-api-info.component.css']
})
export class ProjectApiInfoComponent implements OnInit {

    @Input('project') project!:ProjectDto;
  
    apiInfoForm!: FormGroup;
    projectInfo!: ProjectInfo;
    text: string = "";
    isLoaded: boolean = false;
  
    constructor(
      private formBuilder: FormBuilder,
      //private route: ActivatedRoute,
      //private router: Router,
      //private projectService: ProjectService,
      private tenantService: TenantService,
      //private dataSharingService: DataSharingService,
      public translate: TranslateService,
      //private oauthService: OAuthServiceService,
      private notificationService: NotificationService,
      private clipboard: Clipboard
    ) { }
  

  ngOnInit() {
    this.tenantService.getProjectInfos(this.tenantService.currentTenantName, this.project.id).subscribe({
      next: (projectInfo) => {
        if (projectInfo != null) {
          this.projectInfo = projectInfo;
          this.projectInfo.wpProjectId = this.project.wpProjectId;
          console.log('Project Info:', projectInfo);
          this.buildApiInfoForm(this.projectInfo);
          this.isLoaded = true;
          // this.apiInfoForm.patchValue({
          //   sq3ProjId: projectInfo.sq3ProjectId,
          //   //display_name: projectInfo.display_Name,
          //   //name: projectInfo.name,
          //   //url: projectInfo.url,
          //   // latitude: projectInfo.latitude,
          //   // longitude: projectInfo.longitude,
          //   //description: projectInfo.description,
          //   // color: projectInfo.color
          // });
        }
      },
      error: (error) => {
        //this.notificationService.showError(error);
      }
    });
  }

  buildApiInfoForm(projectInfo: ProjectInfo) {
    this.apiInfoForm = this.formBuilder.group({
      tenantName: [this.tenantService.currentTenantName],
      sq3ProjId: [projectInfo.sq3ProjectId],
      projectId: [projectInfo.projectId],
      //projectId: [projectInfo.wpProjectId],
      environmentId: [projectInfo.environmentId],
      backendUrls: [projectInfo.backendUrls],
      projectName: [projectInfo.projectName],
    });
    console.log('API Info Form:', this.apiInfoForm.value);
  }

  copy(){
    this.text = "Projekt: " + this.apiInfoForm.value.projectName + "\n" +
                "Tenant Name: " + this.apiInfoForm.value.tenantName + "\n" +
                "SQ3 Project ID: " + this.apiInfoForm.value.sq3ProjId + "\n" +
                "Project ID: " + this.apiInfoForm.value.projectId + "\n" +
                "Environment ID: " + this.apiInfoForm.value.environmentId + "\n" +
                "Backend URLs: " + this.apiInfoForm.value.backendUrls.join(", ") + "\n\n" +
                "Token Service: https://environment.squirrel-cde.de/Tenants/";
    this.clipboard.copy(this.text);
    this.notificationService.info("", "API Informationen wurden in die Zwischenablage kopiert!");
  }


}
